import { render, staticRenderFns } from "./MatchingList.vue?vue&type=template&id=46bc87b5"
import script from "./MatchingList.vue?vue&type=script&lang=js"
export * from "./MatchingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports